'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import { useFirestore } from '@/firebase';
import { doc, getDoc } from 'firebase/firestore';

// Default fallback image
const DEFAULT_HEADER_IMAGE = 'https://www.sracinc.org/images/NewRunway1.jpg';

export function HomeHero() {
  const firestore = useFirestore();
  const [headerImageUrl, setHeaderImageUrl] = useState<string>(DEFAULT_HEADER_IMAGE);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchHeaderImage() {
      try {
        // Fetch the homeHeaderImageUrl field from membershipInfo
        const headerImageDoc = await getDoc(doc(firestore, 'membershipInfo', 'homeHeaderImageUrl'));

        if (headerImageDoc.exists()) {
          const data = headerImageDoc.data();
          if (data?.value) {
            setHeaderImageUrl(data.value);
          }
        }
      } catch (error) {
        console.error('Error fetching header image:', error);
        // Keep using the default image
      } finally {
        setIsLoading(false);
      }
    }

    fetchHeaderImage();
  }, [firestore]);

  return (
    <div className="relative h-64 sm:h-80 md:h-96 w-full mb-12">
      <Image
        src={headerImageUrl}
        alt="SRAC Runway"
        fill
        style={{ objectFit: 'cover' }}
        priority
        data-ai-hint="flying field runway"
        className={isLoading ? 'opacity-0' : 'opacity-100 transition-opacity duration-300'}
      />
      {/* Show a placeholder background while loading */}
      {isLoading && (
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 to-primary/5" />
      )}
      <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center text-center text-white p-4">
        <h1 className="font-headline text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight">
          Snohomish Radio Aero Club
        </h1>
        <p className="mt-4 max-w-2xl mx-auto text-lg">
          A premier RC flying club in Snohomish, WA since 1953.
        </p>
      </div>
    </div>
  );
}
